const BARE_UTILITY_IDENTIFIER_PATTERN = /^[a-z][a-z0-9-]*$/i;
const NUMERIC_UTILITY_LITERAL_PATTERN = /^-?(?:\d+\.?\d*|\.\d+)$/;
export function containsTokenReferenceSyntax(value) {
    return value.includes('{') || value.includes('}');
}
export function isBareUtilityIdentifier(value) {
    return BARE_UTILITY_IDENTIFIER_PATTERN.test(value);
}
export function isNumericUtilityLiteral(value) {
    return NUMERIC_UTILITY_LITERAL_PATTERN.test(value);
}
//# sourceMappingURL=utility-value-syntax.js.map